<!--导入报价-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('导入报价')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="ctrl-wrap">
            <el-col :sm="24" :md="18">
                <el-button size="mini" @click="doSelectFile()" type="success"
                    style="margin-right:5px; margin-bottom:5px;">
                    <i class="iconfont icon-xuanzewenjian" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                    </transition>
                </el-button>
                <input ref="fileInput" type="file" style="display:none;" @change="getUploadFile" />
            </el-col>
            <!-- <el-col :sm="24" :md="6">
                <el-button type="primary" size="mini" @click="doDownloadOfferTpl" plain style="margin-bottom:5px;">
                    <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('报价导入模板')}}</span>
                    </transition>
                </el-button>
            </el-col> -->
        </el-row>
        <el-row :gutter="15">
            <el-table :data="results" :height="docHeight" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="sheet" :label="msg('报价名')" min-width="220" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="result" :label="msg('上传结果')" min-width="280" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import XLSX from "xlsx";
export default {
    name: 'OfferImport',
    components: {},
    data(){
        return {
            excelHeads: [],
            excelData: null,
            excelName: null,
            results: [],
        }
    },
    computed: {
        docHeight() {
            var height = this.$store.state.docHeight || 0;
            return Math.max(240, height - 220);
        },
        isMinScreen() {
            return !!this.$store.state.isMinScreen;
        },
    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
            this.results = [];
            this.excelHeads = [];
            this.excelData = null;
            this.excelName = null;
        },
        doSelectFile(){
            this.$refs.fileInput.value = "";
            this.$refs.fileInput.click();
        },
        getUploadFile(e) {
            let that = this;
            this.excelData = null
            this.excelName = null
            let fileName = e.target.files[0];
            if(!fileName){
                return;
            }
            let reader = new FileReader();
            reader.readAsBinaryString(fileName)
            reader.onload = (e) => {
                let workbook = XLSX.read(e.target.result, {type: 'binary'});
                let sheetGroups = [];
                workbook.SheetNames.forEach((sheetName) => {
                    let ws = workbook.Sheets[sheetName];
                    let arr = XLSX.utils.sheet_to_json(ws, {header:1, defval:""});
                    if(Array.isArray(arr)) {
                        // 保留表头行（第1行=结算账号+运费类型名），不做列裁剪；仅剔除「整行全空」的行
                        let rows = arr.filter(row => Array.isArray(row)
                            && row.some(cell => cell !== "" && cell != null && cell !== undefined));
                        if(rows.length > 0) {
                            sheetGroups.push({ sheet: sheetName, rows: rows });
                        }
                    }
                });
                that.excelData = sheetGroups;
                that.excelName = fileName.name;
                this.doUpload();
            };
        },
        // doDownloadOfferTpl(){
        //     var titles = [['账号','报价名','备注'],
        //     [],[],[],
        //     ['说明1：账号必填，系统根据账号匹配用户，必须具有数据权限'],
        //     ['说明2：报价名不填时，默认生成"导入报价_{用户姓名}"'],
        //     ['说明3：备注可以为空'],
        //     ['(导入时说明内容必须删除)']];

        //     var filename = '报价导入模板.xlsx';
        //     var wb = XLSX.utils.book_new();
        //     var ws = XLSX.utils.aoa_to_sheet(titles);
        //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        //     XLSX.writeFile(wb, filename);
        // },
        doUpload(){
            if(!this.excelData || this.excelData.length == 0){
                this.$message(this.msg('请上传一个内容不为空的excel文件'));
                return;
            }
            if(!this.$refs.fileInput || !this.$refs.fileInput.files || !this.$refs.fileInput.files[0]) {
                this.$message(this.msg('原始文件丢失，请重新选择文件'));
                return;
            }
            let formData = new FormData();
            formData.append('excelDatas', JSON.stringify(this.excelData));
            formData.append('file', this.$refs.fileInput.files[0]);

            this.$axios.post(this.$kit.api.financeOffer.doImport, formData, {
                headers:{'Content-Type':'multipart/form-data'}
            }).then((result) => {
                if(result.status){
                    this.results = result.data || [];
                }else{
                    this.$message(result.msg || this.msg('数据错误，请检查表格数据'));
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
